<app-header style="padding: 0px; border-bottom: 0px; height: 80px"></app-header>

<app-menu-sidebar [ngClass]="
        this.updatedtheme === 'dark'
            ? 'sidebarcolorD'
            : this.updatedtheme === 'light'
            ? 'sidebarcolorL'
            
            : 'sidebarcolorL'
    "></app-menu-sidebar>

<div class="content-wrapper " [ngClass]="
        this.updatedtheme === 'dark' ? 'content-wrapperD' : 'content-wrapperL'
    " style="padding: 0px; border-bottom: 0px">
    <router-outlet></router-outlet>
</div>

<app-footer style="padding-top: 34px"></app-footer>
<app-control-sidebar></app-control-sidebar>
<!-- <button style="width: 60px;" id="" (click)="onToggleMenuSidebar()">check</button> -->